export enum UserStatusType {
  Active = 1,
  Pending = 2,
  Revoked = 3,
  Denied = 4,
}
